var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("account_tb.test_validation"),
            isTitleUpperCase: false,
          },
        },
        [
          _c(
            "b-button-group",
            {
              staticClass: "mt-3 mt-sm-0 shadow",
              staticStyle: { display: "grid", "grid-auto-flow": "column" },
            },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "b-button",
                {
                  key: index,
                  staticClass: "responsive-button",
                  attrs: {
                    variant: _vm.tabName === index ? "primary" : "secondary",
                  },
                  on: {
                    click: function ($event) {
                      _vm.tabName = index
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t(tab.translationKey)) +
                      "\n      "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "b-tabs",
            {
              attrs: { "nav-class": "d-none" },
              on: { input: _vm.onTabChange },
              model: {
                value: _vm.tabName,
                callback: function ($$v) {
                  _vm.tabName = $$v
                },
                expression: "tabName",
              },
            },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("account_tb.all") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _vm.activateSpinnerTest
                        ? _c("spinner")
                        : _vm.pieChartDataAll
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("h3", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("account_tb.all")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("pie-chart", {
                                ref: "pieChartAll",
                                attrs: {
                                  id: "myPieChart",
                                  "chart-data": _vm.pieChartDataAll,
                                  options: _vm.chartOptionsAll,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("account_tb.responder") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _vm.activateSpinnerTest
                        ? _c("spinner")
                        : _vm.pieChartDataRes
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("h3", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("account_tb.responder")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("pie-chart", {
                                ref: "pieChartRes",
                                attrs: {
                                  "chart-data": _vm.pieChartDataRes,
                                  options: _vm.chartOptionsRes,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("account_tb.requester") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _vm.activateSpinnerTest
                        ? _c("spinner")
                        : _vm.pieChartDataReq
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("h3", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("account_tb.requester")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("pie-chart", {
                                ref: "pieChartReq",
                                attrs: {
                                  "chart-data": _vm.pieChartDataReq,
                                  options: _vm.chartOptionsReq,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }